import {
  Badge,
  Divider,
  Grid,
  IconButton,
  Menu,
  Theme,
  Typography,
} from '@mui/material';
import React, { FC } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { createStyles, makeStyles } from '@mui/styles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import NotificationRow from './NotificationRow';
import {
  useAcknowledgeNotificationBulkMutation,
  useAcknowledgeNotificationMutation,
  useGetNotificationsQuery,
} from '../../../application';
import { getNotificationContent } from '../Notification';
import { DoneAll, Settings } from '@mui/icons-material';

export const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    menuPaper: {
      padding: '16px',
      width: '600px',
    },
    link: {
      color: '#40B4BF',
      'text-decoration': 'none',
      cursor: 'pointer',
      fontWeight: 'bold' as any,
    },
  })
);

export const NotificationsRaw: FC<RouteComponentProps> = ({ history }) => {
  const classes = useStyles();

  const {
    data: notificationsData,
    isLoading: isNotificationsDataLoading,
    refetch: refetchNotifications,
  } = useGetNotificationsQuery(null, { pollingInterval: 30 * 1000 });

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [acknowledgeNotification] = useAcknowledgeNotificationMutation();
  const [
    bulkAcknowledgeNotification,
  ] = useAcknowledgeNotificationBulkMutation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = async notificationId => {
    await acknowledgeNotification(notificationId).unwrap();
    refetchNotifications();
    handleClose();
  };

  return (
    <>
      {isNotificationsDataLoading && (
        <NotificationsIcon style={{ marginRight: '40px' }} />
      )}
      {!!notificationsData && (
        <>
          <Badge
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            badgeContent={notificationsData.length}
            color="error"
            style={{ marginRight: '40px' }}
            onClick={handleClick}
            overlap="rectangular"
          >
            <NotificationsIcon />
          </Badge>
          <Menu
            id="menu-notifications"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={!!anchorEl}
            onClose={handleClose}
            classes={{ paper: classes.menuPaper }}
            variant="menu"
          >
            <Grid container alignContent="center">
              <Grid item xs={10}>
                <Typography variant="h5">Notifications</Typography>
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  onClick={async () => {
                    if (notificationsData?.length > 0) {
                      // Update all notifications that are presented to user.
                      await bulkAcknowledgeNotification(
                        notificationsData.map(n => n._id)
                      );
                    }
                    handleClose();
                  }}
                  size="large">
                  <DoneAll />
                </IconButton>
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  onClick={() => {
                    history.push('/settings/user#notifications');
                    handleClose();
                  }}
                  size="large">
                  <Settings />
                </IconButton>
              </Grid>
            </Grid>
            {notificationsData.map(notification => (
              <div key={notification._id}>
                <Divider
                  style={{
                    backgroundColor: '#566E8',
                    marginTop: '8px',
                    marginBottom: '8px',
                  }}
                />
                <NotificationRow
                  handleClose={handleClose}
                  handleNotificationClick={handleNotificationClick}
                  {...getNotificationContent(notification)}
                />
              </div>
            ))}
          </Menu>
        </>
      )}
    </>
  );
};

export const Notifications = withRouter(NotificationsRaw);
